import { render, staticRenderFns } from "./EthOrTokensSentToOrFromExchangeHaventShownUp.vue?vue&type=template&id=b5c07d54&scoped=true&"
import script from "./EthOrTokensSentToOrFromExchangeHaventShownUp.vue?vue&type=script&lang=js&"
export * from "./EthOrTokensSentToOrFromExchangeHaventShownUp.vue?vue&type=script&lang=js&"
import style0 from "./EthOrTokensSentToOrFromExchangeHaventShownUp.vue?vue&type=style&index=0&id=b5c07d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c07d54",
  null
  
)

export default component.exports